import Button from "../../../custom/button/button";
import { ReactComponent as Edit } from "../../../assets/Edit.svg";
import { ReactComponent as Cancel } from "../../../assets/cancel.svg";
import styles from "./styles.module.scss";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import { Modal, Spin } from "antd";
import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPersonalInfoByApplicantId } from "../../../utils/request";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import { formatDate } from "../../../utils/formatDate";
import { PersonalInfo } from "../../../components/onboardingSteps";
import { useGetApplicantDetailsQuery } from "../../../hooks/api/useGetApplicantDetailsQuery";

const BioData = () => {
  const [showModal, setShowModal] = useState(false);

  const storedUser = useAtomValue(userAtom);
  const { applicantDetails } = useGetApplicantDetailsQuery({
    applicantId: storedUser?.applicantId,
  });
  const user = applicantDetails ?? storedUser;

  const { data, isLoading } = useQuery({
    queryKey: ["get-personal-info-id"],
    queryFn: () => getPersonalInfoByApplicantId(user?.applicantId ?? ""),
  });

  const personalInfoData = data?.data ?? ({} as PersonalInfo);

  const handleCloseModal = useCallback(() => {
    setShowModal((prevState) => !prevState);
  }, []);

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <>
      <PageLayout
        heading="Bio-Data"
        headerActions={
          <>
            <Button
              onClick={() => {
                setShowModal(true);
              }}
              iconBefore={<Edit />}
              text="Edit"
            />
            {/* <Button
              iconBefore={<Download />}
              text="Download"
              bgColor="#CE9938"
            /> */}
          </>
        }
      >
        <div className={styles.profile_image_col}>
          <div className={styles.profile_image_wrapper}>
            <div className={styles.image}>
              <img
                src={personalInfoData?.imageUrl}
                alt="user_img"
                width="158"
                height="128"
              />
            </div>
          </div>
        </div>

        <section className={styles?.section}>
          <p>Title: {personalInfoData?.title}</p>
          <p>First Name: {personalInfoData?.fName} </p>
          <p>Middle Name: {personalInfoData?.mNane} </p>
          <p>Last Name: {personalInfoData?.lName} </p>

          <p>Program: {user?.programName}</p>
          <p>Program Type: {user?.programType}</p>
          <p>Mode Of Study: {user?.modeOfStudyName}</p>

          <p>Gender: {personalInfoData?.gender} </p>
          <p>Phone No: {personalInfoData?.phoneNo} </p>
          <p>Email: {personalInfoData?.email} </p>
          <p>
            Address: {personalInfoData?.address} {personalInfoData?.zipCode}
          </p>
          <p>Country: {personalInfoData?.countryName}</p>
          <p>Date Of Birth: {formatDate(personalInfoData?.dateOfBirth)}</p>
        </section>
      </PageLayout>

      <Modal
        open={showModal}
        footer=""
        onCancel={() => setShowModal(false)}
        centered
        closeIcon={<Cancel />}
        className="modal"
        width={1000}
      >
        <PersonalInfo isEdit={true} onClose={handleCloseModal} />
      </Modal>
    </>
  );
};

export default BioData;
